import { gql } from '@apollo/client';

export default gql`
  mutation requestHSUser($input: requestHSUserInput!) {
    requestHSUser(input: $input) {
      MessageId
    }
  }
`;
